import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/addObjects/translation.generateTypeValues.mutation.gql"
import type {
  TranslationGenerateTypeValuesMutation,
  TranslationGenerateTypeValuesMutationVariables,
} from "@/v2-backoffice-client/translation/addObjects/__types__/translation.generateTypeValues.mutation"

type Options = MutationHookOptions<
  TranslationGenerateTypeValuesMutation,
  TranslationGenerateTypeValuesMutationVariables
>

export function useTranslationGenerateTypeValuesMutation(options?: Options) {
  return useMutation<
    TranslationGenerateTypeValuesMutation,
    TranslationGenerateTypeValuesMutationVariables
  >(mutation, options)
}
